export const BUILD_VERSION = '1776200478';
